import { motion } from "framer-motion";
import { TrendingUp, Sparkles, ShieldCheck } from "lucide-react";
import { useLang } from "../../lib/i18n";

const icons = [TrendingUp, Sparkles, ShieldCheck];
const nums = ["01", "02", "03"];
const spans = ["md:col-span-4", "md:col-span-5", "md:col-span-3"];

export const Pillars = () => {
  const { t } = useLang();
  return (
    <section id="piliers" className="relative bg-[#FAFAFA] py-24 md:py-32" data-testid="pillars-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl mb-20"
        >
          <p className="font-script text-[#C9A03C] text-2xl mb-4">{t.pillars.eyebrow}</p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight text-logo-gradient pb-1">
            {t.pillars.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-8">
          {t.pillars.cards.map((p, i) => {
            const Icon = icons[i];
            return (
              <motion.article
                key={nums[i]}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                className={`relative bg-white border border-black/5 p-10 md:p-12 group hover:border-[#C9A03C]/40 transition-colors duration-500 ${spans[i]}`}
                data-testid={`pillar-card-${nums[i]}`}
              >
                <span className="absolute top-6 right-8 font-serif-lux text-7xl md:text-8xl text-[#0A192F]/[0.05] font-bold select-none group-hover:text-[#C9A03C]/10 transition-colors duration-500">
                  {nums[i]}
                </span>
                <Icon className="w-7 h-7 text-[#C9A03C] mb-8" strokeWidth={1.5} />
                <h3 className="font-serif-lux text-xl md:text-2xl text-[#0A192F] font-semibold leading-snug mb-6">{p.title}</h3>
                <ul className="space-y-3">
                  {p.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-[#0A192F]/70 font-light leading-relaxed">
                      <span className="mt-2 w-1 h-1 rounded-full bg-[#C9A03C] shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
